import http from '@/communication/AuthConnection'

export default (pData) => {
  return http.post('/v1/occupation', pData)
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/occupation/AddNewOccupation.js